module.exports = __webpack_public_path__ + "static/media/sort-circle-up.a8285632.svg";